import "@fortawesome/fontawesome-free/css/all.min.css";
import { createBrowserRouter, createRoutesFromElements, Route } from "react-router-dom";
import AdminPage from "./pages/admin/AdminPage";
import AgreementPage from "./pages/public/AgreementPage";
import ApplicationListPage from "./pages/public/ApplicationListPage";
import BsrsPage from "./pages/public/BsrsPage";
import CaseDetailPage from "./pages/public/CaseDetailPage";
import LoginPage from "./pages/LoginPage";
import MeasurePage from "./pages/public/MeasurePage";
import NewApplicationStep1Page from "./pages/public/NewApplicationStep1Page";
import NewApplicationStep2Page from "./pages/public/NewApplicationStep2Page";
import NewApplicationStep3Page from "./pages/public/NewApplicationStep3Page";
import NotFoundPage from "./pages/NotFoundPage";
import OrganizationListPage from "./pages/public/OrganizationListPage";
import PlatformPage from "./pages/public/PlatformPage";
import PostListPage from "pages/public/PostListPage";
import PostPage from "pages/public/PostPage";
import PrivacyTermsPage from "./pages/public/PrivacyTermsPage";
import ResetPasswordPage from "./pages/public/ResetPasswordPage";
import UserTermsPage from "./pages/public/UserTermsPage";
import UserUsageTermsPage from "./pages/public/UserUsageTermsPage";
import VaccineListPage from "pages/public/VaccineListPage";

export const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route path="/vaccineList" element={<VaccineListPage />} />
      <Route path="/organizationList" element={<OrganizationListPage />} />
      <Route path="/infoList" element={<PostListPage />} />
      <Route path="/infoList/c/:categoryId" element={<PostListPage />} />
      <Route path="/infoList/p/:postId" element={<PostPage />} />
      <Route path="/platform" element={<PlatformPage />} />
      <Route path="/measure" element={<MeasurePage />} />
      <Route path="/bsrs" element={<BsrsPage />} />
      <Route path="/applicationList" element={<ApplicationListPage />} />
      <Route path="/caseDetail/:id" element={<CaseDetailPage />} />
      <Route path="/userTerms" element={<UserTermsPage />} />
      <Route path="/userUsageTerms" element={<UserUsageTermsPage />} />
      <Route path="/privacyTerms" element={<PrivacyTermsPage />} />
      <Route path="/resetPassword" element={<ResetPasswordPage />} />
      <Route path="/agreement" element={<AgreementPage />} />
      <Route path="/login" element={<LoginPage />} />

      <Route path="/admin/:content" element={<AdminPage />} />
      <Route path="/newApplicationStep1/:category" element={<NewApplicationStep1Page />} />
      <Route path="/newApplicationStep2/:category" element={<NewApplicationStep2Page />} />
      <Route path="/newApplicationStep3/:category" element={<NewApplicationStep3Page />} />
      <Route path="*" element={<NotFoundPage />} />
    </>
  )
);
